import { t } from 'i18next';

class Translations {
	private keys = {
		loadingReservationsText: 'loading_reservations_text',
		onlyTheMostRecentReservationsShownText: 'only_the_most_recent_reservations_shown_text',
		homeScreen: 'homeScreen',
		close: 'close',
		done: 'done',
		delete: 'delete',
		perPersonShort: 'per_person_short',
		startingFromShort: 'starting_from_short',
		bookNow: 'book_now',
		moreInfo: 'more_info',
		next: 'next',
		previous: 'previous',
		loginOrRegister: 'login_or_register',
		cancel: 'cancel',
		areYouSureYouWantToLogout: 'are_you_sure_you_want_to_logout',
		continue: 'continue',
		doLogin: 'do_login',
		doRegister: 'do_register',
		loginWithPassword: 'login_with_password',
		loginWithMagiclink: 'login_with_magiclink',
		madam: 'madam',
		sir: 'sir',
		genderPreferNotToSay: 'gender_prefer_not_to_say',
		goBack: 'go_back',
		firstName: 'first_name',
		infixName: 'infix_name',
		lastName: 'last_name',
		emailAddress: 'email_address',
		emailAddressInvalid: 'email_address_invalid',
		password: 'password',
		passwordWithRules: 'password_with_rules',
		repeatPassword: 'repeat_password',
		resend: 'resend',
		youAreAlmostThere: 'you_are_almost_there',
		unknownErrorOccurred: 'unknown_error_occurred',
		view: 'view',
		book: 'book',
		sendAMessage: 'sendAMessage',
		checkYourEmailAndClickOnTheLinkToConfirmYourRegistration:
			'check_your_email_and_click_on_the_link_to_confirm_your_registration',
		areYouSureYouWantToResetYourPassword: 'are_you_sure_you_want_to_reset_your_password',
		anEmailIsOnItsWayToYou: 'an_email_is_on_its_way_to_you',
		yourAccountMustBeVerifiedBeforeYouCanLogInAnEmailHasBeenSentToYouWithAVerificationLink:
			'your_account_must_be_verified_before_you_can_log_in_an_email_has_been_sent_to_you_with_a_verification_link',
		clickOnTheLinkInTheEmailToLogInImmediatelyDidntReceiveAnEmailItMayTakeAFewMinutesBeforeYouReceiveTheEmailAlsoJustToBeSureCheckYourJunkMail:
			'click_on_the_link_in_the_email_to_log_in_immediately_didnt_receive_an_email_it_may_take_a_few_minutes_before_you_receive_the_email_also_just_to_be_sure_check_your_junk_mail',
		messageCategoryBooking: 'message_category_booking',
		messageCategoryNews: 'message_category_news',
		showAll: 'show_all',
		messages: 'messages',
		message: 'message',
		replyOnThisMessage: 'reply_on_this_message',
		send: 'send',
		sendAs: 'sendAs',
		subject: 'subject',
		reservationNumberFormTitle: 'reservation_number_form_title',
		reservationNumber: 'reservation_number',
		somethingWentWrongTitle: 'something_went_wrong_title',
		somethingWentWrongMessage: 'something_went_wrong_message',
		tryAgain: 'try_again',
		thermenResortGeneralFormTitle: 'thermen_resort_general_form_title',
		thermenResortGeneral: 'thermen_resort_general',
		selectAThermenResort: 'select_a_thermen_resort',
		save: 'save',
		yourAdjustmentHasBeenProcessedInOurDatabaseItMayTakeUpTo24HoursForYourAdjustmentToBeProcessed:
			'your_adjustment_has_been_processed_in_our_database_it_may_take_up_to_24_hours_for_your_adjustment_to_be_processed',
		notAvailableShort: 'not_available_short',
		video: 'video',
		response: 'response',
		yourResponseHasBeenSent: 'your_response_has_been_sent',
		thanksForYourMessageWeWillContactYouByEmailAsSoonAsPossible:
			'thanks_for_your_message_we_will_contact_you_by_email_as_soon_as_possible',
		pleaseNoteHaveYouRequestedAChangeYouWillThenReceiveANewConfirmationOfYourAdjustedReservationByEmailFromUsAsSoonAsYouHaveReceivedThisEmailThisChangeWillAlsoBeVisibleInTheAppWithinAnHour:
			'please_note_have_you_requested_a_change_you_will_then_receive_a_new_confirmation_of_your_adjusted_reservation_by_email_from_us_as_soon_as_you_have_received_this_email_this_change_will_also_be_visible_in_the_app_within_an_hour',
		resortInfo: 'resort_info',
		deleteAccount: 'delete_account',
		areYouSureYouWantToDeleteYourAccount: 'are_you_sure_you_want_to_delete_your_account',
		currentPassword: 'current_password',
		add: 'add',
		videoTutorials: 'video_tutorials',
		tutorialsTitle: 'tutorials_title',
		tutorialsDescription: 'tutorials_description',
		whichReservationAreYouReportingAboutQuestion: 'which_reservation_are_you_reporting_about_question',
		optional: 'optional',
		generalThermenResorts: 'general_thermen_resorts',
		ignore: 'ignore',
		update: 'update',
		swimwearDay: 'swimwear_day',
		filterSwimwearDays: 'filter_swimwear_days',
		appVersion: 'app_version',
		addReservationManuallyDescription: 'add_reservation_manually_description',
		enterManually: 'enter_manually',
		addReservationManually: 'add_reservation_manually',
		fillInAllRequiredFields: 'fill_in_all_required_fields',
		onboardingStep1Header: 'onboarding.step1.header',
		onboardingStep1Description: 'onboarding.step1.description',
		onboardingStep2Header: 'onboarding.step2.header',
		onboardingStep2Description: 'onboarding.step2.description',
		onboardingStep3Header: 'onboarding.step3.header',
		onboardingStep3Description: 'onboarding.step3.description',
		onboardingStep4Header: 'onboarding.step4.header',
		onboardingStep4Description: 'onboarding.step4.description',
		loginOverlayTagline: 'login.overlay_tagline',
		loginStep1Header: 'login.step1.header',
		loginStep1Description: 'login.step1.description',
		loginStep2Header: 'login.step2.header',
		loginStep3Header: 'login.step3.header',
		loginForgotPasswordLink: 'login.forgot_password_link',
		loginEmailPasswordCombinationInvalidError: 'login.email_password_combination_invalid_error',
		loginMagiclinkInvalidError: 'login.magiclink_invalid_error',
		registerStep2Header: 'register.step2.header',
		registerStep2Description: 'register.step2.description',
		preferencesUpcomingReservations: 'Preferences.upcomingReservations',
		preferencesLanguage: 'Preferences.language',
		preferencesEnglish: 'Preferences.english',
		preferencesGerman: 'Preferences.german',
		preferencesSpanish: 'Preferences.spanish',
		preferencesRussian: 'Preferences.russian',
		dashboardPrepareTitle: 'dashboard.prepare.title',
		resortContact: 'resort.contact',
		resortRouteDescription: 'resort.routeDescription',
		homeUpcomingReservations: 'home.upcomingReservations',
		homeTitle: 'home.title',
		homeCompleteStay: 'home.completeStay',
		homeDiscover: 'home.discover',
		homeDiscoverMore: 'home.discoverMore',
		homeEasyBooking: 'home.easyBooking',
		homeComeResorts: 'home.comeResorts',
		homeManageBooking: 'home.manageBooking',
		homeArrangeApp: 'home.arrangeApp',
		homeFeatured: 'home.featured',
		homeFeaturedSubtitle: 'home.featuredSubtitle',
		homeArrangement: 'home.arrangement',
		homeMostBooked: 'home.mostBooked',
		homeDiscoverOurThermenResorts: 'home.discoverOurThermenResorts',
		homeReserveVisit: 'home.reserveVisit',
		homeReserve: 'home.reserve',
		homeViewReservation: 'home.viewReservation',
		homeShowBarcode: 'home.showBarcode',
		tabsHome: 'tabs.home',
		tabsBooking: 'tabs.booking',
		tabsThermenfans: 'tabs.thermenfans',
		tabsRelaxation: 'tabs.relaxation',
		tabsBathCard: 'tabs.bathCard',
		tabsAccount: 'tabs.account',
		headersAccount: 'headers.account',
		reserveUrl: 'reserve.url',
		reserveWithLoyalty: 'reserve.withLoyalty',
		reserveWithLoyaltyDescription: 'reserve.withLoyaltyDescription',
		reserveWithBathCard: 'reserve.withBathCard',
		reserveWithBathCardDescription: 'reserve.withBathCardDescription',
		reserveStandard: 'reserve.standard',
		reserveStandardDescription: 'reserve.standardDescription',
		reserveLeaveAppDescription: 'reserve.leaveAppDescription',
		leaveAppTitle: 'leaveApp.title',
		leaveAppDescription: 'leaveApp.description',
		leaveAppConfirm: 'leaveApp.confirm',
		bathcardUrl: 'bathcard.url',
		bathcardAddBathcard: 'bathcard.addBathcard',
		bathcardBuyBathcard: 'bathcard.buyBathcard',
		bathcardLeaveAppDescription: 'bathcard.leaveAppDescription',
		bathcardBalanceDelayTooltip: 'bathcard.balanceDelayTooltip',
		bathcardAreYouSureDeleteBathcard: 'bathcard.areYouSureDeleteBathcard',
		bathcardAreYouSureUnlinkBathcard: 'bathcard.areYouSureUnlinkBathcard',
		bathcardCards: 'bathcard.cards',
		bathcardLoading: 'bathcard.loading',
		bathcardCardSummary: 'bathcard.cardSummary',
		bathcardCardSummaryWithoutExpiry: 'bathcard.cardSummaryWithoutExpiry',
		bathcardVisitOne: 'bathcard.visitOne',
		bathcardVisitsOther: 'bathcard.visitsOther',
		bathcardReserve: 'bathcard.reserve',
		bathcardNoCardHeading: 'bathcard.noCardHeading',
		bathcardExtraCardHeading: 'bathcard.extraCardHeading',
		bathcardAcquireIntro: 'bathcard.acquireIntro',
		bathcardLinkCard: 'bathcard.linkCard',
		bathcardBuyCard: 'bathcard.buyCard',
		bathcardUspsTitle: 'bathcard.uspsTitle',
		bathcardYourBathcard: 'bathcard.yourBathcard',
		bathcardView: 'bathcard.view',
		bathcardBuyNewCard: 'bathcard.buyNewCard',
		bathcardRemoveThisCard: 'bathcard.removeThisCard',
		bathcardUnlink: 'bathcard.unlink',
		bathcardUnlinkThisCard: 'bathcard.unlinkThisCard',
		loyaltySelectResort: 'loyalty.selectResort',
		loyaltySale: 'loyalty.sale',
		loyaltyRedeem: 'loyalty.redeem',
		loyaltyMoreInfo: 'loyalty.moreInfo',
		loyaltyDiscoverMyBenefits: 'loyalty.discoverMyBenefits',
		loyaltyDownloadVoucher: 'loyalty.download_voucher',
		loyaltyBenefits: 'loyalty.benefits',
		loyaltyPersonalBenefitsWithCount: 'loyalty.personalBenefitsWithCount',
		loyaltyBenefitsSubtitle: 'loyalty.benefitsSubtitle',
		loyaltyUseBenefit: 'loyalty.useBenefit',
		loyaltyBenefitUsed: 'loyalty.benefitUsed',
		loyaltyUseThisBenefit: 'loyalty.useThisBenefit',
		loyaltyYouUsedThisBenefit: 'loyalty.youUsedThisBenefit',
		accountUpcomingReservations: 'account.upcomingReservations',
		accountPastReservations: 'account.pastReservations',
		accountNoUpcomingReservations: 'account.noUpcomingReservations',
		accountNoPastReservations: 'account.noPastReservations',
		accountMyDetails: 'account.myDetails',
		accountMail: 'account.mail',
		accountChangePersonalDetails: 'account.changePersonalDetails',
		accountChangeAdressDetails: 'account.changeAdressDetails',
		accountCloseModal: 'account.closeModal',
		accountResetConfirm: 'account.resetConfirm',
		accountResetConfirmed: 'account.resetConfirmed',
		accountResetDescription: 'account.resetDescription',
		accountResetDescriptionSuccess: 'account.resetDescriptionSuccess',
		accountResetPassword: 'account.resetPassword',
		accountAttention: 'account.attention',
		accountDeleteWarning: 'account.deleteWarning',
		accountMyPreferences: 'account.myPreferences',
		accountPreferencesNotifications: 'account.preferences.notifications',
		accountPreferencesEmails: 'account.preferences.emails',
		accountPreferencesPreferredLanguage: 'account.preferences.preferredLanguage',
		accountPreferencesNewsletterDetail: 'account.preferences.newsletterDetail',
		accountPreferencesLanguageDetail: 'account.preferences.languageDetail',
		accountEmailDescriptionPreferences: 'account.emailDescriptionPreferences',
		accountSendAMessage: 'account.sendAMessage',
		accountAppExplanation: 'account.appExplanation',
		accountLogout: 'account.logout',
		resetpasswordCloseModal: 'resetpassword.closeModal',
		resetpasswordResetConfirm: 'resetpassword.resetConfirm',
		resetpasswordResetConfirmed: 'resetpassword.resetConfirmed',
		resetpasswordResetDescription: 'resetpassword.resetDescription',
		resetpasswordResetDescriptionSuccess: 'resetpassword.resetDescriptionSuccess',
		resetpasswordResetPassword: 'resetpassword.resetPassword',
		reservationBookAgain: 'reservation.bookAgain',
		reservationViewReservation: 'reservation.viewReservation',
		reservationId: 'reservation.id',
		reservationBooking: 'reservation.booking',
		reservationLocation: 'reservation.location',
		reservationPrice: 'reservation.price',
		reservationQuestionOrChange: 'reservation.questionOrChange',
		reservationAddPreferencesHeading: 'reservation.addPreferencesHeading',
		reservationAddPreferences: 'reservation.addPreferences',
		reservationAddPreferencesText: 'reservation.addPreferencesText',
		reservationSendAMessage: 'reservation.sendAMessage',
		reservationCallUs: 'reservation.callUs',
		reservationPersonCount: 'reservation.personCount',
		reservationPersonCounts: 'reservation.personCounts',
		reservationShowBarcode: 'reservation.showBarcode',
		reservationUnknown: 'reservation.unknown',
		reservationIncluded: 'reservation.included',
		reservationYourReservation: 'reservation.yourReservation',
		dialogBarcode: 'dialog.barcode',
		settingsUpdateAvailable: 'settings.update_available',
		settingsUpdateAvailableDescription: 'settings.update_available_description',
		settingsUpdateAvailableMandatory: 'settings.update_available_mandatory',
		settingsUpdateAvailableMandatoryDescription: 'settings.update_available_mandatory_description',
		settingsUpdateAvailableVersionText: 'settings.update_available_version_text',
		selectResort: 'select_resort',
		selectResortError: 'select_resort_error',
		enterSubject: 'enter_subject',
		enterMessage: 'enter_message',
		urlCouldNotBeOpenedTitle: 'url_could_not_be_opened_title',
		urlCouldNotBeOpenedDescription: 'url_could_not_be_opened_description',
		copyUrl: 'copy_url',
		okay: 'okay',
		readMore: 'readMore',
		checkYourAdvantages: 'check_your_advantages',
		exclusiveAccessToPersonalAdvantages: 'exclusive_access_to_personal_advantages',
		easyWayToManageYourReservations: 'easy_way_to_manage_your_reservations',
		enjoyRelaxationAtHome: 'enjoy_relaxation_at_home',
		durationMinutes: 'duration_minutes',
		exerciseOfTheDay: 'exercise_of_the_day',
		playVideo: 'play_video',
		stopVideo: 'stop_video',
		unavailableInActiveLocaleMessage: 'unavailable_in_active_locale_message',
	};

	get loadingReservationsText(): string {
		return t(this.keys.loadingReservationsText);
	}

	get onlyTheMostRecentReservationsShownText(): string {
		return t(this.keys.onlyTheMostRecentReservationsShownText);
	}

	get homeScreen(): string {
		return t(this.keys.homeScreen);
	}

	get close(): string {
		return t(this.keys.close);
	}

	get done(): string {
		return t(this.keys.done);
	}

	get delete(): string {
		return t(this.keys.delete);
	}

	get perPersonShort(): string {
		return t(this.keys.perPersonShort);
	}

	get startingFromShort(): string {
		return t(this.keys.startingFromShort);
	}

	get bookNow(): string {
		return t(this.keys.bookNow);
	}

	get moreInfo(): string {
		return t(this.keys.moreInfo);
	}

	get next(): string {
		return t(this.keys.next);
	}

	get previous(): string {
		return t(this.keys.previous);
	}

	get loginOrRegister(): string {
		return t(this.keys.loginOrRegister);
	}

	get cancel(): string {
		return t(this.keys.cancel);
	}

	get areYouSureYouWantToLogout(): string {
		return t(this.keys.areYouSureYouWantToLogout);
	}

	get continue(): string {
		return t(this.keys.continue);
	}

	get doLogin(): string {
		return t(this.keys.doLogin);
	}

	get doRegister(): string {
		return t(this.keys.doRegister);
	}

	get loginWithPassword(): string {
		return t(this.keys.loginWithPassword);
	}

	get loginWithMagiclink(): string {
		return t(this.keys.loginWithMagiclink);
	}

	get madam(): string {
		return t(this.keys.madam);
	}

	get sir(): string {
		return t(this.keys.sir);
	}

	get genderPreferNotToSay(): string {
		return t(this.keys.genderPreferNotToSay);
	}

	get goBack(): string {
		return t(this.keys.goBack);
	}

	get firstName(): string {
		return t(this.keys.firstName);
	}

	get infixName(): string {
		return t(this.keys.infixName);
	}

	get lastName(): string {
		return t(this.keys.lastName);
	}

	get emailAddress(): string {
		return t(this.keys.emailAddress);
	}

	get emailAddressInvalid(): string {
		return t(this.keys.emailAddressInvalid);
	}

	get password(): string {
		return t(this.keys.password);
	}

	get passwordWithRules(): string {
		return t(this.keys.passwordWithRules);
	}

	get repeatPassword(): string {
		return t(this.keys.repeatPassword);
	}

	get resend(): string {
		return t(this.keys.resend);
	}

	get youAreAlmostThere(): string {
		return t(this.keys.youAreAlmostThere);
	}

	get unknownErrorOccurred(): string {
		return t(this.keys.unknownErrorOccurred);
	}

	get view(): string {
		return t(this.keys.view);
	}

	get book(): string {
		return t(this.keys.book);
	}

	get sendAMessage(): string {
		return t(this.keys.sendAMessage);
	}

	get checkYourEmailAndClickOnTheLinkToConfirmYourRegistration(): string {
		return t(this.keys.checkYourEmailAndClickOnTheLinkToConfirmYourRegistration);
	}

	get areYouSureYouWantToResetYourPassword(): string {
		return t(this.keys.areYouSureYouWantToResetYourPassword);
	}

	get anEmailIsOnItsWayToYou(): string {
		return t(this.keys.anEmailIsOnItsWayToYou);
	}

	get yourAccountMustBeVerifiedBeforeYouCanLogInAnEmailHasBeenSentToYouWithAVerificationLink(): string {
		return t(this.keys.yourAccountMustBeVerifiedBeforeYouCanLogInAnEmailHasBeenSentToYouWithAVerificationLink);
	}

	get clickOnTheLinkInTheEmailToLogInImmediatelyDidntReceiveAnEmailItMayTakeAFewMinutesBeforeYouReceiveTheEmailAlsoJustToBeSureCheckYourJunkMail(): string {
		return t(
			this.keys
				.clickOnTheLinkInTheEmailToLogInImmediatelyDidntReceiveAnEmailItMayTakeAFewMinutesBeforeYouReceiveTheEmailAlsoJustToBeSureCheckYourJunkMail,
		);
	}

	get messageCategoryBooking(): string {
		return t(this.keys.messageCategoryBooking);
	}

	get messageCategoryNews(): string {
		return t(this.keys.messageCategoryNews);
	}

	get showAll(): string {
		return t(this.keys.showAll);
	}

	get messages(): string {
		return t(this.keys.messages);
	}

	get message(): string {
		return t(this.keys.message);
	}

	get replyOnThisMessage(): string {
		return t(this.keys.replyOnThisMessage);
	}

	get send(): string {
		return t(this.keys.send);
	}

	get sendAs(): string {
		return t(this.keys.sendAs);
	}

	get subject(): string {
		return t(this.keys.subject);
	}

	get reservationNumberFormTitle(): string {
		return t(this.keys.reservationNumberFormTitle);
	}

	get reservationNumber(): string {
		return t(this.keys.reservationNumber);
	}

	get somethingWentWrongTitle(): string {
		return t(this.keys.somethingWentWrongTitle);
	}

	get somethingWentWrongMessage(): string {
		return t(this.keys.somethingWentWrongMessage);
	}

	get tryAgain(): string {
		return t(this.keys.tryAgain);
	}

	get thermenResortGeneralFormTitle(): string {
		return t(this.keys.thermenResortGeneralFormTitle);
	}

	get thermenResortGeneral(): string {
		return t(this.keys.thermenResortGeneral);
	}

	get selectAThermenResort(): string {
		return t(this.keys.selectAThermenResort);
	}

	get save(): string {
		return t(this.keys.save);
	}

	get yourAdjustmentHasBeenProcessedInOurDatabaseItMayTakeUpTo24HoursForYourAdjustmentToBeProcessed(): string {
		return t(this.keys.yourAdjustmentHasBeenProcessedInOurDatabaseItMayTakeUpTo24HoursForYourAdjustmentToBeProcessed);
	}

	get notAvailableShort(): string {
		return t(this.keys.notAvailableShort);
	}

	get video(): string {
		return t(this.keys.video);
	}

	get response(): string {
		return t(this.keys.response);
	}

	get yourResponseHasBeenSent(): string {
		return t(this.keys.yourResponseHasBeenSent);
	}

	get thanksForYourMessageWeWillContactYouByEmailAsSoonAsPossible(): string {
		return t(this.keys.thanksForYourMessageWeWillContactYouByEmailAsSoonAsPossible);
	}

	get pleaseNoteHaveYouRequestedAChangeYouWillThenReceiveANewConfirmationOfYourAdjustedReservationByEmailFromUsAsSoonAsYouHaveReceivedThisEmailThisChangeWillAlsoBeVisibleInTheAppWithinAnHour(): string {
		return t(
			this.keys
				.pleaseNoteHaveYouRequestedAChangeYouWillThenReceiveANewConfirmationOfYourAdjustedReservationByEmailFromUsAsSoonAsYouHaveReceivedThisEmailThisChangeWillAlsoBeVisibleInTheAppWithinAnHour,
		);
	}

	get resortInfo(): string {
		return t(this.keys.resortInfo);
	}

	get deleteAccount(): string {
		return t(this.keys.deleteAccount);
	}

	get areYouSureYouWantToDeleteYourAccount(): string {
		return t(this.keys.areYouSureYouWantToDeleteYourAccount);
	}

	get currentPassword(): string {
		return t(this.keys.currentPassword);
	}

	get add(): string {
		return t(this.keys.add);
	}

	get videoTutorials(): string {
		return t(this.keys.videoTutorials);
	}

	get tutorialsTitle(): string {
		return t(this.keys.tutorialsTitle);
	}

	get tutorialsDescription(): string {
		return t(this.keys.tutorialsDescription);
	}

	get whichReservationAreYouReportingAboutQuestion(): string {
		return t(this.keys.whichReservationAreYouReportingAboutQuestion);
	}

	get optional(): string {
		return t(this.keys.optional);
	}

	get generalThermenResorts(): string {
		return t(this.keys.generalThermenResorts);
	}

	get ignore(): string {
		return t(this.keys.ignore);
	}

	get update(): string {
		return t(this.keys.update);
	}

	get swimwearDay(): string {
		return t(this.keys.swimwearDay);
	}

	get filterSwimwearDays(): string {
		return t(this.keys.filterSwimwearDays);
	}

	appVersion(appVersion: string | undefined, buildVersion: string | number): string {
		return t(this.keys.appVersion, { appVersion, buildVersion });
	}

	get addReservationManuallyDescription(): string {
		return t(this.keys.addReservationManuallyDescription);
	}

	get enterManually(): string {
		return t(this.keys.enterManually);
	}

	get addReservationManually(): string {
		return t(this.keys.addReservationManually);
	}

	get fillInAllRequiredFields(): string {
		return t(this.keys.fillInAllRequiredFields);
	}

	get onboardingStep1Header(): string {
		return t(this.keys.onboardingStep1Header);
	}

	get onboardingStep1Description(): string {
		return t(this.keys.onboardingStep1Description);
	}

	get onboardingStep2Header(): string {
		return t(this.keys.onboardingStep2Header);
	}

	get onboardingStep2Description(): string {
		return t(this.keys.onboardingStep2Description);
	}

	get onboardingStep3Header(): string {
		return t(this.keys.onboardingStep3Header);
	}

	get onboardingStep3Description(): string {
		return t(this.keys.onboardingStep3Description);
	}

	get onboardingStep4Header(): string {
		return t(this.keys.onboardingStep4Header);
	}

	get onboardingStep4Description(): string {
		return t(this.keys.onboardingStep4Description);
	}

	get loginOverlayTagline(): string {
		return t(this.keys.loginOverlayTagline);
	}

	get loginStep1Header(): string {
		return t(this.keys.loginStep1Header);
	}

	get loginStep1Description(): string {
		return t(this.keys.loginStep1Description);
	}

	get loginStep2Header(): string {
		return t(this.keys.loginStep2Header);
	}

	get loginStep3Header(): string {
		return t(this.keys.loginStep3Header);
	}

	get loginForgotPasswordLink(): string {
		return t(this.keys.loginForgotPasswordLink);
	}

	get loginEmailPasswordCombinationInvalidError(): string {
		return t(this.keys.loginEmailPasswordCombinationInvalidError);
	}

	get loginMagiclinkInvalidError(): string {
		return t(this.keys.loginMagiclinkInvalidError);
	}

	get registerStep2Header(): string {
		return t(this.keys.registerStep2Header);
	}

	get registerStep2Description(): string {
		return t(this.keys.registerStep2Description);
	}

	get preferencesUpcomingReservations(): string {
		return t(this.keys.preferencesUpcomingReservations);
	}

	get preferencesLanguage(): string {
		return t(this.keys.preferencesLanguage);
	}

	get preferencesEnglish(): string {
		return t(this.keys.preferencesEnglish);
	}

	get preferencesGerman(): string {
		return t(this.keys.preferencesGerman);
	}

	get preferencesSpanish(): string {
		return t(this.keys.preferencesSpanish);
	}

	get preferencesRussian(): string {
		return t(this.keys.preferencesRussian);
	}

	get dashboardPrepareTitle(): string {
		return t(this.keys.dashboardPrepareTitle);
	}

	get resortContact(): string {
		return t(this.keys.resortContact);
	}

	get resortRouteDescription(): string {
		return t(this.keys.resortRouteDescription);
	}

	get homeUpcomingReservations(): string {
		return t(this.keys.homeUpcomingReservations);
	}

	get homeTitle(): string {
		return t(this.keys.homeTitle);
	}

	get homeCompleteStay(): string {
		return t(this.keys.homeCompleteStay);
	}

	get homeDiscover(): string {
		return t(this.keys.homeDiscover);
	}

	get homeDiscoverMore(): string {
		return t(this.keys.homeDiscoverMore);
	}

	get homeEasyBooking(): string {
		return t(this.keys.homeEasyBooking);
	}

	get homeComeResorts(): string {
		return t(this.keys.homeComeResorts);
	}

	get homeManageBooking(): string {
		return t(this.keys.homeManageBooking);
	}

	get homeArrangeApp(): string {
		return t(this.keys.homeArrangeApp);
	}

	get homeFeatured(): string {
		return t(this.keys.homeFeatured);
	}

	get homeFeaturedSubtitle(): string {
		return t(this.keys.homeFeaturedSubtitle);
	}

	get homeArrangement(): string {
		return t(this.keys.homeArrangement);
	}

	get homeMostBooked(): string {
		return t(this.keys.homeMostBooked);
	}

	get homeDiscoverOurThermenResorts(): string {
		return t(this.keys.homeDiscoverOurThermenResorts);
	}

	get homeReserveVisit(): string {
		return t(this.keys.homeReserveVisit);
	}

	get homeReserve(): string {
		return t(this.keys.homeReserve);
	}

	get homeViewReservation(): string {
		return t(this.keys.homeViewReservation);
	}

	get homeShowBarcode(): string {
		return t(this.keys.homeShowBarcode);
	}

	get tabsHome(): string {
		return t(this.keys.tabsHome);
	}

	get tabsBooking(): string {
		return t(this.keys.tabsBooking);
	}

	get tabsThermenfans(): string {
		return t(this.keys.tabsThermenfans);
	}

	get tabsRelaxation(): string {
		return t(this.keys.tabsRelaxation);
	}

	get tabsBathCard(): string {
		return t(this.keys.tabsBathCard);
	}

	get tabsAccount(): string {
		return t(this.keys.tabsAccount);
	}

	get headersAccount(): string {
		return t(this.keys.headersAccount);
	}

	get reserveUrl(): string {
		return t(this.keys.reserveUrl);
	}

	get reserveWithLoyalty(): string {
		return t(this.keys.reserveWithLoyalty);
	}

	get reserveWithLoyaltyDescription(): string {
		return t(this.keys.reserveWithLoyaltyDescription);
	}

	get reserveWithBathCard(): string {
		return t(this.keys.reserveWithBathCard);
	}

	get reserveWithBathCardDescription(): string {
		return t(this.keys.reserveWithBathCardDescription);
	}

	get reserveStandard(): string {
		return t(this.keys.reserveStandard);
	}

	get reserveStandardDescription(): string {
		return t(this.keys.reserveStandardDescription);
	}

	get reserveLeaveAppDescription(): string {
		return t(this.keys.reserveLeaveAppDescription);
	}

	get leaveAppTitle(): string {
		return t(this.keys.leaveAppTitle);
	}

	get leaveAppDescription(): string {
		return t(this.keys.leaveAppDescription);
	}

	get leaveAppConfirm(): string {
		return t(this.keys.leaveAppConfirm);
	}

	get bathcardUrl(): string {
		return t(this.keys.bathcardUrl);
	}

	get bathcardAddBathcard(): string {
		return t(this.keys.bathcardAddBathcard);
	}

	get bathcardBuyBathcard(): string {
		return t(this.keys.bathcardBuyBathcard);
	}

	get bathcardLeaveAppDescription(): string {
		return t(this.keys.bathcardLeaveAppDescription);
	}

	get bathcardBalanceDelayTooltip(): string {
		return t(this.keys.bathcardBalanceDelayTooltip);
	}

	get bathcardAreYouSureDeleteBathcard(): string {
		return t(this.keys.bathcardAreYouSureDeleteBathcard);
	}

	get bathcardAreYouSureUnlinkBathcard(): string {
		return t(this.keys.bathcardAreYouSureUnlinkBathcard);
	}

	get bathcardCards(): string {
		return t(this.keys.bathcardCards);
	}

	get bathcardLoading(): string {
		return t(this.keys.bathcardLoading);
	}

	bathcardCardSummary({ visits, date, workspace }: { visits: string; date: string; workspace: string }): string {
		return t(this.keys.bathcardCardSummary, { visits, date, workspace });
	}

	bathcardCardSummaryWithoutExpiry({ visits, workspace }: { visits: string; workspace: string }): string {
		return t(this.keys.bathcardCardSummaryWithoutExpiry, { visits, workspace });
	}

	get bathcardVisitOne(): string {
		return t(this.keys.bathcardVisitOne);
	}

	bathcardVisitsOther(count: number): string {
		return t(this.keys.bathcardVisitsOther, { count });
	}

	get bathcardReserve(): string {
		return t(this.keys.bathcardReserve);
	}

	get bathcardNoCardHeading(): string {
		return t(this.keys.bathcardNoCardHeading);
	}

	get bathcardExtraCardHeading(): string {
		return t(this.keys.bathcardExtraCardHeading);
	}

	get bathcardAcquireIntro(): string {
		return t(this.keys.bathcardAcquireIntro);
	}

	get bathcardLinkCard(): string {
		return t(this.keys.bathcardLinkCard);
	}

	get bathcardBuyCard(): string {
		return t(this.keys.bathcardBuyCard);
	}

	get bathcardUspsTitle(): string {
		return t(this.keys.bathcardUspsTitle);
	}

	get bathcardYourBathcard(): string {
		return t(this.keys.bathcardYourBathcard);
	}

	get bathcardView(): string {
		return t(this.keys.bathcardView);
	}

	get bathcardBuyNewCard(): string {
		return t(this.keys.bathcardBuyNewCard);
	}

	get bathcardRemoveThisCard(): string {
		return t(this.keys.bathcardRemoveThisCard);
	}

	get bathcardUnlink(): string {
		return t(this.keys.bathcardUnlink);
	}

	get bathcardUnlinkThisCard(): string {
		return t(this.keys.bathcardUnlinkThisCard);
	}

	get loyaltySelectResort(): string {
		return t(this.keys.loyaltySelectResort);
	}

	get loyaltySale(): string {
		return t(this.keys.loyaltySale);
	}

	get loyaltyRedeem(): string {
		return t(this.keys.loyaltyRedeem);
	}

	get loyaltyMoreInfo(): string {
		return t(this.keys.loyaltyMoreInfo);
	}

	get loyaltyDiscoverMyBenefits(): string {
		return t(this.keys.loyaltyDiscoverMyBenefits);
	}

	get loyaltyDownloadVoucher(): string {
		return t(this.keys.loyaltyDownloadVoucher);
	}

	get loyaltyBenefits(): string {
		return t(this.keys.loyaltyBenefits);
	}

	loyaltyPersonalBenefitsWithCount(count: number): string {
		return t(this.keys.loyaltyPersonalBenefitsWithCount, { count });
	}

	get loyaltyBenefitsSubtitle(): string {
		return t(this.keys.loyaltyBenefitsSubtitle);
	}

	get loyaltyUseBenefit(): string {
		return t(this.keys.loyaltyUseBenefit);
	}

	get loyaltyBenefitUsed(): string {
		return t(this.keys.loyaltyBenefitUsed);
	}

	get loyaltyUseThisBenefit(): string {
		return t(this.keys.loyaltyUseThisBenefit);
	}

	get loyaltyYouUsedThisBenefit(): string {
		return t(this.keys.loyaltyYouUsedThisBenefit);
	}

	get accountUpcomingReservations(): string {
		return t(this.keys.accountUpcomingReservations);
	}

	get accountPastReservations(): string {
		return t(this.keys.accountPastReservations);
	}

	get accountNoUpcomingReservations(): string {
		return t(this.keys.accountNoUpcomingReservations);
	}

	get accountNoPastReservations(): string {
		return t(this.keys.accountNoPastReservations);
	}

	get accountMyDetails(): string {
		return t(this.keys.accountMyDetails);
	}

	get accountMail(): string {
		return t(this.keys.accountMail);
	}

	get accountChangePersonalDetails(): string {
		return t(this.keys.accountChangePersonalDetails);
	}

	get accountChangeAdressDetails(): string {
		return t(this.keys.accountChangeAdressDetails);
	}

	get accountCloseModal(): string {
		return t(this.keys.accountCloseModal);
	}

	get accountResetConfirm(): string {
		return t(this.keys.accountResetConfirm);
	}

	get accountResetConfirmed(): string {
		return t(this.keys.accountResetConfirmed);
	}

	get accountResetDescription(): string {
		return t(this.keys.accountResetDescription);
	}

	get accountResetDescriptionSuccess(): string {
		return t(this.keys.accountResetDescriptionSuccess);
	}

	get accountResetPassword(): string {
		return t(this.keys.accountResetPassword);
	}

	get accountAttention(): string {
		return t(this.keys.accountAttention);
	}

	get accountDeleteWarning(): string {
		return t(this.keys.accountDeleteWarning);
	}

	get accountMyPreferences(): string {
		return t(this.keys.accountMyPreferences);
	}

	get accountPreferencesNotifications(): string {
		return t(this.keys.accountPreferencesNotifications);
	}

	get accountPreferencesEmails(): string {
		return t(this.keys.accountPreferencesEmails);
	}

	get accountPreferencesPreferredLanguage(): string {
		return t(this.keys.accountPreferencesPreferredLanguage);
	}

	get accountPreferencesNewsletterDetail(): string {
		return t(this.keys.accountPreferencesNewsletterDetail);
	}

	get accountPreferencesLanguageDetail(): string {
		return t(this.keys.accountPreferencesLanguageDetail);
	}

	get accountEmailDescriptionPreferences(): string {
		return t(this.keys.accountEmailDescriptionPreferences);
	}

	get accountSendAMessage(): string {
		return t(this.keys.accountSendAMessage);
	}

	get accountAppExplanation(): string {
		return t(this.keys.accountAppExplanation);
	}

	get accountLogout(): string {
		return t(this.keys.accountLogout);
	}

	get resetpasswordCloseModal(): string {
		return t(this.keys.resetpasswordCloseModal);
	}

	get resetpasswordResetConfirm(): string {
		return t(this.keys.resetpasswordResetConfirm);
	}

	get resetpasswordResetConfirmed(): string {
		return t(this.keys.resetpasswordResetConfirmed);
	}

	get resetpasswordResetDescription(): string {
		return t(this.keys.resetpasswordResetDescription);
	}

	get resetpasswordResetDescriptionSuccess(): string {
		return t(this.keys.resetpasswordResetDescriptionSuccess);
	}

	get resetpasswordResetPassword(): string {
		return t(this.keys.resetpasswordResetPassword);
	}

	get reservationBookAgain(): string {
		return t(this.keys.reservationBookAgain);
	}

	get reservationViewReservation(): string {
		return t(this.keys.reservationViewReservation);
	}

	get reservationId(): string {
		return t(this.keys.reservationId);
	}

	get reservationBooking(): string {
		return t(this.keys.reservationBooking);
	}

	get reservationLocation(): string {
		return t(this.keys.reservationLocation);
	}

	get reservationPrice(): string {
		return t(this.keys.reservationPrice);
	}

	get reservationQuestionOrChange(): string {
		return t(this.keys.reservationQuestionOrChange);
	}

	get reservationAddPreferencesHeading(): string {
		return t(this.keys.reservationAddPreferencesHeading);
	}

	get reservationAddPreferences(): string {
		return t(this.keys.reservationAddPreferences);
	}

	get reservationAddPreferencesText(): string {
		return t(this.keys.reservationAddPreferencesText);
	}

	get reservationSendAMessage(): string {
		return t(this.keys.reservationSendAMessage);
	}

	get reservationCallUs(): string {
		return t(this.keys.reservationCallUs);
	}

	get reservationPersonCount(): string {
		return t(this.keys.reservationPersonCount);
	}

	get reservationPersonCounts(): string {
		return t(this.keys.reservationPersonCounts);
	}

	get reservationShowBarcode(): string {
		return t(this.keys.reservationShowBarcode);
	}

	get reservationUnknown(): string {
		return t(this.keys.reservationUnknown);
	}

	get reservationIncluded(): string {
		return t(this.keys.reservationIncluded);
	}

	get reservationYourReservation(): string {
		return t(this.keys.reservationYourReservation);
	}

	get dialogBarcode(): string {
		return t(this.keys.dialogBarcode);
	}

	get settingsUpdateAvailable(): string {
		return t(this.keys.settingsUpdateAvailable);
	}

	get settingsUpdateAvailableDescription(): string {
		return t(this.keys.settingsUpdateAvailableDescription);
	}

	get settingsUpdateAvailableMandatory(): string {
		return t(this.keys.settingsUpdateAvailableMandatory);
	}

	get settingsUpdateAvailableMandatoryDescription(): string {
		return t(this.keys.settingsUpdateAvailableMandatoryDescription);
	}

	settingsUpdateAvailableVersionText(currentVersion: string | undefined, newVersion: string): string {
		return t(this.keys.settingsUpdateAvailableVersionText, { currentVersion, newVersion });
	}

	get selectResort(): string {
		return t(this.keys.selectResort);
	}

	get selectResortError(): string {
		return t(this.keys.selectResortError);
	}

	get enterSubject(): string {
		return t(this.keys.enterSubject);
	}

	get enterMessage(): string {
		return t(this.keys.enterMessage);
	}

	get urlCouldNotBeOpenedTitle(): string {
		return t(this.keys.urlCouldNotBeOpenedTitle);
	}

	get urlCouldNotBeOpenedDescription(): string {
		return t(this.keys.urlCouldNotBeOpenedDescription);
	}

	get copyUrl(): string {
		return t(this.keys.copyUrl);
	}

	get okay(): string {
		return t(this.keys.okay);
	}

	get readMore(): string {
		return t(this.keys.readMore);
	}

	get checkYourAdvantages(): string {
		return t(this.keys.checkYourAdvantages);
	}

	get exclusiveAccessToPersonalAdvantages(): string {
		return t(this.keys.exclusiveAccessToPersonalAdvantages);
	}

	get easyWayToManageYourReservations(): string {
		return t(this.keys.easyWayToManageYourReservations);
	}

	get enjoyRelaxationAtHome(): string {
		return t(this.keys.enjoyRelaxationAtHome);
	}

	durationMinutes(minutes: number): string {
		return t(this.keys.durationMinutes, { minutes });
	}

	get exerciseOfTheDay(): string {
		return t(this.keys.exerciseOfTheDay);
	}

	get playVideo(): string {
		return t(this.keys.playVideo);
	}

	get stopVideo(): string {
		return t(this.keys.stopVideo);
	}

	get unavailableInActiveLocaleMessage(): string {
		return t(this.keys.unavailableInActiveLocaleMessage);
	}
}

export default new Translations();
